export default [

     {
          path: '/project',
          name: 'Project',
          component: () => import("@/views/Page/StrategicPlan/Project/Project.vue"),
           meta: {
               title: 'Project',
          },
     }
];